import f from "./ghl-ui.es786.js";
var u = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function D(t, r, a) {
  var e = new f(a);
  if (e.selectNumberingPlan(t, r), e.defaultIDDPrefix())
    return e.defaultIDDPrefix();
  if (u.test(e.IDDPrefix()))
    return e.IDDPrefix();
}
export {
  D as default
};
